/**
 * Known OTP error types
 */
export enum OTPErrorType {
  INVALID_OTP = 'INVALID_OTP',
  MAX_ATTEMPTS_REACHED = 'MAX_ATTEMPTS_REACHED',
  EXPIRED_CODE = 'EXPIRED_CODE',
  MFA_EXPIRED = 'MFA_EXPIRED',
  UNKNOWN = 'UNKNOWN',
}

enum MFAErrorCodes {
  INVALID_OTP = 'invalid otp code',
  INVALID_MFA_TOKEN = 'invalid mfa token',
  MAX_ATTEMPTS_REACHED = 'maximum attempts reached. request a new code to continue.',
  MFA_EXPIRED = 'mfa_expired',
}

/**
 * Mapping of backend error messages to typed errors
 */
const ERROR_MESSAGES: Record<string, { type: OTPErrorType; message: string }> = {
  [MFAErrorCodes.INVALID_OTP]: {
    type: OTPErrorType.INVALID_OTP,
    message: 'Incorrect code. Please try again.',
  },
  [MFAErrorCodes.MAX_ATTEMPTS_REACHED]: {
    type: OTPErrorType.MAX_ATTEMPTS_REACHED,
    message: 'Maximum attempts reached. Request a new code to continue.',
  },
  [MFAErrorCodes.INVALID_MFA_TOKEN]: {
    type: OTPErrorType.EXPIRED_CODE,
    message: 'Incorrect code. Please try again.',
  },
  [MFAErrorCodes.MFA_EXPIRED]: {
    type: OTPErrorType.MFA_EXPIRED,
    message: 'Session has timed out. Request a new code to continue.',
  },
};

/**
 * Maps a backend error message to a typed error
 */
export const mapOTPError = (
  errorMessage: string,
): { type: OTPErrorType; message: string } => {
  const normalizedError = errorMessage.toLowerCase().trim();

  // Exact match
  if (ERROR_MESSAGES[normalizedError]) {
    return ERROR_MESSAGES[normalizedError];
  }

  // Partial match for cases where the message may come with prefixes/suffixes
  const matchedKey = Object.keys(ERROR_MESSAGES).find((key) =>
    normalizedError.includes(key),
  );

  if (matchedKey && ERROR_MESSAGES[matchedKey]) {
    return ERROR_MESSAGES[matchedKey];
  }

  // Return generic error if no match is found
  return {
    type: OTPErrorType.UNKNOWN,
    message: errorMessage || 'An error occurred. Please try again.',
  };
};
